import { Icon } from '@festina-life/ui/structure'
import cx from 'classnames'
import type { ReactNode } from 'react'

import type { ConfigurationItem } from '../../types/common'

const TemplateLeafIconsByType: Record<ConfigurationItem, string | ReactNode> = {
  template: 'T',
  hideTemplate: <Icon name="EyeSlash" />,
  parameterDefinition: 'P',
  parameterValue: 'P',
  parameterValueAmendment: 'P',
  library: 'L',
  enumDefinition: 'E',
  enumLiteral: 'E',
  tenant: <Icon name="BuildingOffice" color="unset" />,
  glMap: <Icon name="TableCells" color="unset" />,
  hideGlMap: <Icon name="EyeSlash" />,
  reconciliationSpec: <Icon name="DocumentCheck" color="unset" />,
  annulOperation: <Icon name="NoSymbol" />,
}

type Props = {
  type: keyof typeof TemplateLeafIconsByType
}

export const ConfigurationItemIcon = ({ type }: Props) => (
  <div
    className={cx('font-medium text-inheritance', {
      'ml-1': typeof TemplateLeafIconsByType[type] === 'string',
    })}
  >
    {TemplateLeafIconsByType[type]}
  </div>
)
